import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllSubjectApi,
  createSubjectApi,
  updateSubjectApi,
  deleteSubjectApi,
} from "../../apis/curriculumManagement";

export const getAllSubjects = createAsyncThunk("subject/getall", async () => {
  const response = await getAllSubjectApi();
  return response.data.data;
});

// create course -
export const createSubject = createAsyncThunk(
  "subject/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createSubjectApi(formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create subject"
      );
    }
  }
);

export const deleteSubject = createAsyncThunk(
  "subject/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteSubjectApi(id);
      return id; // Return deleted subject ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete subject"
      );
    }
  }
);

export const updateSubject = createAsyncThunk(
  "subject/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateSubjectApi(id, formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update course"
      );
    }
  }
);

const subjectSlice = createSlice({
  name: "subject",
  initialState: {
    subjects: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubjects.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllSubjects.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subjects = action.payload;
      })
      .addCase(getAllSubjects.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Something went wrong.";
      })

      // create subjects
      .addCase(createSubject.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createSubject.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subjects.push(action.payload);
      })
      .addCase(createSubject.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create course.";
      })

      // update subject

      .addCase(updateSubject.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateSubject.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subjects = state.subjects.map((course) =>
          course.id === action.payload.id ? action.payload : course
        ); // Update the course in state
      })
      .addCase(updateSubject.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update course.";
      })

      // delete subject
      .addCase(deleteSubject.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteSubject.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subjects = state.subjects.filter(
          (deleteSubject) => deleteSubject.id !== action.payload
        ); 
      })
      .addCase(deleteSubject.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete course.";
      });
  },
});

export default subjectSlice.reducer;
